// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SidebarAccordionController from "./sidebar_accordion_controller"
application.register("sidebar-accordion", SidebarAccordionController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PhoneModalController from "./phone_modal_controller"
application.register("phone-modal", PhoneModalController)

import PhoneNumberSearchController from "./phone_number_search_controller"
application.register("phone-number-search", PhoneNumberSearchController)

import EmailBuilderController from "./email_builder_controller"
application.register("email-builder", EmailBuilderController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)
